export const QUERY_KEYS = {
  AUTH_CURRENT_GET: "AUTH_CURRENT_GET",
  AUTH_LOGIN_POST: "AUTH_LOGIN_POST",
  CITAJTEO_TOPIC_GET: "CITAJTEO_TOPIC_GET",
  CITAJTEO_TOPIC_LIST_GET: "CITAJTEO_TOPIC_LIST_GET",
  CITAJTEO_TOPIC_SEARCH: "CITAJTEO_TOPIC_SEARCH",
  CITAJTEO_TOPIC_STATISTIC: "CITAJTEO_TOPIC_STATISTIC",
  CITAJTEO_TOPIC_ANSWER_PLAY_CHARACTER: "CITAJTEO_TOPIC_ANSWER_PLAY_CHARACTER",
  CITAJTEO_USER_GET: "CITAJTEO_USER_GET",
  CITAJTEO_USER_LIST_GET: "CITAJTEO_USER_LIST_GET",
  CITAJTEO_USER_SEARCH: "CITAJTEO_USER_SEARCH",
  CITAJTEO_CHARACTER_GET: "CITAJTEO_CHARACTER_GET",
  CITAJTEO_CHARACTER_LIST_GET: "CITAJTEO_CHARACTER_LIST_GET",
  CITAJTEO_CHARACTER_SEARCH: "CITAJTEO_CHARACTER_SEARCH",
  CITAJTEO_TAG_GET: "CITAJTEO_TAG_GET",
  CITAJTEO_TAG_LIST_GET: "CITAJTEO_TAG_LIST_GET",
  CITAJTEO_TAG_SEARCH: "CITAJTEO_TAG_SEARCH",
  CITAJTEO_DL_UNIT_GET: "CITAJTEO_DL_UNIT_GET",
  CITAJTEO_DL_UNIT_SEARCH: "CITAJTEO_DL_UNIT_SEARCH",
  CITAJTEO_PHOTO_SERIES_GET: "CITAJTEO_PHOTO_SERIES_GET",
  CITAJTEO_PHOTO_SERIES_SEARCH: "CITAJTEO_PHOTO_SERIES_SEARCH",
};
